import { useState } from "preact/hooks";
import { Route, Router, getCurrentUrl } from "preact-router";

import enabledFeatures from "../settings/enabledFeatures";
import Header from "./header";
import Footer from "./footer";
// import Banner from "./banner";
// import Link from "./link";

import { PopupRoot } from "./popup";
import { PopupProvider } from "./popup/context";
import { scrollToHashElement, scrollToTop } from "./scrollToHash";

// Code-splitting is automated for routes
import Home from "../routes/home";
import WhyAttend from "../routes/why-attend";
import Speakers from "../routes/speakers";
import Details from "../routes/details";
import History from "../routes/history";

import Sponsors from "../routes/sponsors";
import Merchandise from "../routes/merchandise";
import Vendors from "../routes/shop-local";
import Classes from "../routes/classes";

import Contact from "../routes/contact";
import NotFound from "../routes/not-found";

import namedRoutes from "../settings/routes";

const App = () => {
  let [currentUrl, setCurrentUrl] = useState(getCurrentUrl());

  const handleRoute = async (e) => {
    setCurrentUrl(e.url);

    if (typeof window !== "undefined") {
      if (
        e.url.includes("#") ||
        (window.location.hash && window.location.hash.length > 1)
      ) {
        scrollToHashElement();
      } else {
        scrollToTop();
      }
    }
  };

  return (
    <PopupProvider>
      <div id="app">
        <PopupRoot />
        {/* <Banner>
        <Link href="/#tbd">Get your tickets</Link>
      </Banner> */}
        <Header />
        <main>
          <div class="wrapper">
            <Router url={currentUrl} onChange={handleRoute}>
              <Route component={Home} path={namedRoutes.home} />
              <Route component={WhyAttend} path={namedRoutes.whyAttend} />
              <Route component={Speakers} path={namedRoutes.speakers} />
              <Route component={Details} path={namedRoutes.details} />
              <Route component={History} path={namedRoutes.history} />
              <Route component={Sponsors} path={namedRoutes.sponsors} />
              {enabledFeatures.merchandise ? (
                <Route component={Merchandise} path={namedRoutes.merch} />
              ) : null}
              <Route component={Vendors} path={namedRoutes.vendors} />
              <Route component={Classes} path={namedRoutes.classes} />
              <Route component={Contact} path={namedRoutes.contact} />
              <Route component={NotFound} default />
            </Router>
          </div>
        </main>
        <Footer />
      </div>
    </PopupProvider>
  );
};

export default App;
